// extracted by mini-css-extract-plugin
module.exports = {"container":"OversiktHeader_container__iya08","header":"OversiktHeader_header__E6RSL","subHeader":"OversiktHeader_subHeader__iNGl6"};